import { gql } from '@apollo/client'

export const userUpsertCommunitySpaces = gql`
  mutation UserUpsertCommunitySpaces {
    userUpsertCommunitySpaces
  }
`
